import { useCallback, useMemo } from "react";
import { useHistory, useLocation } from "react-router-dom";

import type { unstable_AdapterOptions as AdapterOptions } from "nuqs/adapters/custom";

import {
  unstable_createAdapterProvider as createAdapterProvider,
  renderQueryString,
} from "nuqs/adapters/custom";

function useNuqsReactRouterAdapter() {
  const history = useHistory();
  const location = useLocation();
  const searchParams = useMemo(
    () => new URLSearchParams(location.search),
    [location.search],
  );

  const updateUrl = useCallback(
    (search: URLSearchParams, options: AdapterOptions) => {
      const queryString = renderQueryString(search);
      const hash = location.hash;

      switch (options.history) {
        case "push":
          history.push({ search: queryString, hash });
          break;
        case "replace":
          history.replace({ search: queryString, hash });
          break;
        default:
          throw new Error("Invalid history option");
      }
    },
    [history, location.hash],
  );

  return { searchParams, updateUrl };
}

export const NuqsAdapter = createAdapterProvider(useNuqsReactRouterAdapter);
